import { tokens } from '@equinor/eds-tokens';

const comfortable = tokens.spacings.comfortable;

export const spacings = {
  /** 2px */
  XX_SMALL: comfortable.xx_small,
  /** 4px */
  X_SMALL: comfortable.x_small,
  /** 8px */
  SMALL: comfortable.small,
  /** 12px */
  MEDIUM_SMALL: comfortable.medium_small,
  /** 16px */
  MEDIUM: comfortable.medium,
  /** 24px */
  LARGE: comfortable.large,
  /** 32px */
  X_LARGE: comfortable.x_large,
  /** 40px */
  XX_LARGE: comfortable.xx_large,
  /** 48px */
  XXX_LARGE: comfortable.xxx_large,
  /** 64px */
  XXXX_LARGE: '64px',
  /** 75,5px */
  NAME_FRAME: '75,5px',
  /** 92px */
  COMPUTE_BUTTON: '92px',
  /** 5px */
  CARD_ROUNDED: '5px',
  /** 4px */
  BORDER_ROUNDED: '4px', // CARD_ROUNDED - 1px
};
